<template>
  <div>
    <h3>Admin Controll Pannel</h3>
    <div>
      <h5>authorization</h5>
        <div>
          key: <input type='text' v-model='key' />
        </div>
        <div>
          <router-link v-bind:to="'/admin/posts'" class="nav-link">edit posts</router-link> <router-link v-bind:to="'/admin/photos'" class="nav-link">edit photos</router-link>
          <router-view></router-view>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      key: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin.vue